import { categoryPaths } from '@config/categories'

export function getIsValidCategoryPath(categoryPath: unknown) {
    if (categoryPaths.includes(categoryPath as any)) {
        return true
    }
    return false
}
